import { useEffect, useContext } from 'react';

import { useAlloyFeatureFlag } from '@adsk/alloy-provider';

import { SubmittalsContext } from '../components/Provider';
import { SUBMITTALS_CUSTOM_ATTRIBUTES_FF } from '../consts';

export default function useCustomAttributes() {
  const { value: isCustomAttributesEnabled } = useAlloyFeatureFlag(
    SUBMITTALS_CUSTOM_ATTRIBUTES_FF,
    true,
  );

  const {
    customAttributes: { data, isLoading, error, fetchCustomAttributes },
  } = useContext(SubmittalsContext) || {
    customAttributes: {
      data: [],
      isLoading: false,
      error: null,
      fetchCustomAttributes: () => {},
    },
  };

  useEffect(() => {
    if (isCustomAttributesEnabled) {
      fetchCustomAttributes();
    }
  }, [fetchCustomAttributes, isCustomAttributesEnabled]);

  return {
    ...(isCustomAttributesEnabled
      ? { customAttributes: data, isLoading, error }
      : { customAttributes: [], isLoading: false, error: null }),
  };
}
